module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACvSURBVHgB7dnRCcMwDEVRpRt0g27WbN5ukGygytC/unWJTZ5t7oGQnyjoERtkYgYAU3D3e1ybf/dIz1iv3g2WbNbYYo2k7v55bgnW0MUGRwA1AqgRQI0AavIAtTOUfJRIDcbtVijbo+yafZ81UhGgaoaabw/4YHP9x2c5uiZVSygX4NRG2AM2OAKoEUCNAGoEUCOAGgHUpgywW9mzg7q8OF+s/vtvSzpuruo6AOjDC16ZQds4U/n5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu2.png
// module id = PWuZ
// module chunks = 1